
import React, { createContext, useState, useCallback } from 'react';

export const AccessibilityContext = createContext();

export const AccessibilityProvider = ({ children }) => {
  const [contrasteActivo, setContrasteActivo] = useState(false);
  const [aumentarActivo, setAumentarActivo] = useState(false);
  const [disminuirActivo, setDisminuirActivo] = useState(false);
  const [fontSize, setFontSize] = useState(16); // Tamaño de fuente inicial, puedes ajustarlo

  const cambiarContexto = useCallback(() => {
    setContrasteActivo(prev => !prev);
    setAumentarActivo(false);
    setDisminuirActivo(false);
  }, []);

  const disminuirTamanio = useCallback(() => {
    setDisminuirActivo(prev => !prev);
    setAumentarActivo(false);
    setContrasteActivo(false);
    setFontSize(prev => Math.max(prev - 1, 10)); // Límite inferior de 10px
  }, []);

  const aumentarTamanio = useCallback(() => {
    setAumentarActivo(prev => !prev);
    setDisminuirActivo(false);
    setContrasteActivo(false);
    setFontSize(prev => Math.min(prev + 1, 64)); // Límite superior de 64px, como en tu código original
  }, []);

  return (
    <AccessibilityContext.Provider
      value={{
        contrasteActivo,
        aumentarActivo,
        disminuirActivo,
        fontSize,
        cambiarContexto,
        disminuirTamanio,
        aumentarTamanio,
      }}
    >
      {children}
    </AccessibilityContext.Provider>
  );
};
